import { bopApi } from '@/lib/api/client';

const PATH = 'v1/users/futures/client-categorisation';

/** Wire enum values are lowercase */
export const CLIENT_CATEGORISATIONS = ['retail', 'professional'] as const;
export type ClientCategorisation = (typeof CLIENT_CATEGORISATIONS)[number];

/**
 * Row from POST /v1/users/futures/client-categorisation. `email`/`segment` are
 * server-side enrichments whose misses are NORMAL — a miss leaves the
 * field undefined; no row is dropped.
 */
export interface UserClientCategorisation {
  pid: string;
  /** The treatment record's `d` attribute — ISO timestamp */
  date: string;
  categorisation: ClientCategorisation;
  email?: string;
  segment?: string;
}

/**
 * One LEK page. `cursor` is an OPAQUE base64 DynamoDB LastEvaluatedKey validated
 * upstream — roundtrip verbatim, never construct or edit. The key is
 * omitted when the query is exhausted.
 */
export interface ClientCategorisationPage {
  cursor?: string;
  data: UserClientCategorisation[];
}

/** Flat wire body (the legacy BFF's `{ cursor, filters }` flattening, done client-side) */
export interface ClientCategorisationRequest {
  cursor?: string;
  categorisation?: ClientCategorisation;
}

/** Pure request builder: flattens (cursor, categorisation) into the request body */
export const buildClientCategorisationRequest = (cursor?: string, categorisation?: ClientCategorisation): ClientCategorisationRequest => ({
  ...(cursor ? { cursor } : {}),
  ...(categorisation ? { categorisation } : {}),
});

/**
 * Export `parameters` mirror the ACTIVE filter verbatim — `{}` when none
 * (easy to miss and export everything).
 */
export const buildClientCategorisationExportParameters = (categorisation?: ClientCategorisation): { categorisation?: ClientCategorisation } =>
  categorisation ? { categorisation } : {};

/** Page size is fixed at 100 upstream — there is no page-size parameter */
export const getClientCategorisationPage = (cursor?: string, categorisation?: ClientCategorisation) =>
  bopApi.post(PATH, { json: buildClientCategorisationRequest(cursor, categorisation) }).json<ClientCategorisationPage>();
